module.exports = __webpack_public_path__ + "img/hotel_3.6e0c227f.png";